(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ceika-native-pilot-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ceika-native-pilot-gallery')) {
    customElements.define('ceika-native-pilot-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const views = [...this.querySelectorAll('[data-pilot-image]')];
        const thumbnails = [...this.querySelectorAll('[data-pilot-thumbnail]')];
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-pilot-thumbnail]');
          if (!button || !this.contains(button)) return;
          const selectedIndex = button.dataset.pilotThumbnail;
          views.forEach(view => { view.hidden = view.dataset.pilotImage !== selectedIndex; });
          thumbnails.forEach(thumbnail => {
            thumbnail.setAttribute('aria-pressed', String(thumbnail === button));
          });
        });
        const controls = this.querySelector('[data-pilot-thumbnails]');
        if (controls) controls.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
